import { GlSkeletonLoader } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'CatalogListSkeletonLoader',
    components: {
        GlSkeletonLoader
    },
    data () {
        return {
            coordinates: {
                statsX: 0,
                releaseDateX: 0
            },
            width: 0
        };
    },
    mounted () {
        this.setSvgSize();
    },
    methods: {
        setSvgSize () {
            this.width = this.$el.offsetWidth;
            this.coordinates.releaseDateX = this.width - 200;
            this.coordinates.statsX = this.width - 90;
        }
    },
    skeletonLoadItems: new Array(5)
};
